import { languageGlobal } from "./GlobalVariableConfig";

export const getManifest = () => {
    return {
        bundles: [
            {
                name: 'intro-screen',
                assets: [
                    {
                        alias: 'volatilityBase',
                        src: 'assets/desktop/intro/vol_base.webp',
                    },
                    {
                        alias: 'volatilityOn',
                        src: 'assets/desktop/intro/coin_on.webp',
                    },
                    {
                        alias: 'volatilityOff',
                        src: 'assets/desktop/intro/coin_off.webp',
                    },
                    {
                        alias: 'textBase1',
                        src: 'assets/desktop/intro/text_base_1.webp',
                    },
                    {
                        alias: 'textBase2',
                        src: 'assets/desktop/intro/text_base_2.webp',
                    },
                    {
                        alias: 'textBase3',
                        src: 'assets/desktop/intro/text_base_3.webp',
                    },
                    {
                        alias: 'image1',
                        src: 'assets/desktop/intro/image_1.webp',
                    },
                    {
                        alias: 'image2',
                        src: 'assets/desktop/intro/image_2.webp',
                    },
                    {
                        alias: 'image3',
                        src: 'assets/desktop/intro/image_3.webp',
                    },
                    // {
                    //     alias: 'continueBase',
                    //     src: './intro/click_base.webp',
                    // },
                    // {
                    //     alias: 'introAppearSound',
                    //     src: 'assets/desktop/sound/gameloading/Intro_appear.mp3',
                    // },
                ]
            },
            {
                name: 'big-win',
                assets: [
                    {
                        alias: 'bigWinSkel',
                        src: languageGlobal === 'es-es' ? 'assets/desktop/bigwin/es/win_celebration_spanish.skel' : 'assets/desktop/bigwin/win_celebration.skel',
                    },
                    {
                        alias: 'bigWinAtlas',
                        src: languageGlobal === 'es-es' ? 'assets/desktop/bigwin/es/win_celebration_spanish.atlas' : 'assets/desktop/bigwin/win_celebration.atlas',
                    },
                    // {
                    //     alias: 'amount_base',
                    //     src: 'assets/desktop/bigwin/win_amount_base.webp',
                    // },
                ]
            },
            {
                name: 'game-screen',
                assets: [
                    {
                        alias: 'background',
                        src: 'assets/desktop/base/basegame.webp',
                    },
                    {
                        alias: 'backgroundFree',
                        src: 'assets/desktop/base/freegame.webp',
                    },
                    // reels back
                    {
                        alias: 'reelBackSkel',
                        src: 'assets/desktop/base/reel/reel.skel',
                    },
                    {
                        alias: 'reelBackAtlas',
                        src: 'assets/desktop/base/reel/reel.atlas',
                    },
                    //  waterfall on reels intro
                    {
                        alias: 'reelWaterfallSkel',
                        src: 'assets/desktop/base/waterfall/waterfall.skel',
                    },
                    {
                        alias: 'reelWaterfallAtlas',
                        src: 'assets/desktop/base/waterfall/waterfall.atlas',
                    },
                    // Slides in reel back
                    {
                        alias: 'reelBackSliderSkel',
                        src: 'assets/desktop/base/slider/slider.skel',
                    },
                    {
                        alias: 'reelBackSliderAtlas',
                        src: 'assets/desktop/base/slider/slider.atlas',
                    },
                    // win collection meter
                    {
                        alias: 'meterSkel',
                        src: 'assets/desktop/base/meter/meter.skel',
                    },
                    {
                        alias: 'meterAtlas',
                        src: 'assets/desktop/base/meter/meter.atlas',
                    },
                    //win multiplier base 
                    {
                        alias: 'multiplier_base',
                        src: 'assets/desktop/base/win_muliplier/multiplier_base.webp',
                    },
                    //win multiplierFx 
                    {
                        alias: 'multFxSkel',
                        src: 'assets/desktop/base/win_muliplier/multiplier_fx/multiplier_fx.skel',
                    },
                    {
                        alias: 'multFxAtlas',
                        src: 'assets/desktop/base/win_muliplier/multiplier_fx/multiplier_fx.atlas',
                    },
                    //win multiplier font
                    {
                        alias: 'sugar_multiplier',
                        src: 'assets/desktop/base/win_muliplier/multiplier_font/sugar_multiplier.xml',
                    },
                    //logo *********************
                    {
                        alias: 'logoStatic',
                        src: 'assets/desktop/base/logo.webp',
                    },
                    // //logo animation *********************
                    {
                        alias: 'logoSkel',
                        src: 'assets/desktop/base/logo/logo.skel',
                    },
                    {
                        alias: 'logoAtlas',
                        src: 'assets/desktop/base/logo/logo.atlas',
                    },
                    //banner *********************
                    // {
                    //     alias: 'banner',
                    //     src: 'assets/desktop/banner/intro_outro_base.webp',
                    // },
                    //banner-spine
                    {
                        alias: 'bannerSkel',
                        src: 'assets/desktop/banner/outro.skel',
                    },
                    {
                        alias: 'bannerAtlas',
                        src: 'assets/desktop/banner/outro.atlas',
                    },
                    //base game background animation
                    {
                        alias: 'baseBackgroundSkel',
                        src: 'assets/desktop/base/baseBgAnimation/basegame.skel',
                    },
                    {
                        alias: 'baseBackgroundAtlas',
                        src: 'assets/desktop/base/baseBgAnimation/basegame.atlas',
                    },
                    //free game background animation
                    {
                        alias: 'freeBackgroundSkel',
                        src: 'assets/desktop/base/freeBgAnimation/freegame.skel',
                    },
                    {
                        alias: 'freeBackgroundAtlas',
                        src: 'assets/desktop/base/freeBgAnimation/freegame.atlas',
                    },
                    //symbols *********************
                    //hv1
                    {
                        alias: 'hv1Skel',
                        src: 'assets/desktop/symbols/hv1/hv1.skel',
                    },
                    {
                        alias: 'hv1Atlas',
                        src: 'assets/desktop/symbols/hv1/hv1.atlas',
                    },
                    //hv2
                    {
                        alias: 'hv2Skel',
                        src: 'assets/desktop/symbols/hv2/hv2.skel',
                    },
                    {
                        alias: 'hv2Atlas',
                        src: 'assets/desktop/symbols/hv2/hv2.atlas',
                    },
                    //hv3
                    {
                        alias: 'hv3Skel',
                        src: 'assets/desktop/symbols/hv3/hv3.skel',
                    },
                    {
                        alias: 'hv3Atlas',
                        src: 'assets/desktop/symbols/hv3/hv3.atlas',
                    },
                    //hv4
                    {
                        alias: 'hv4Skel',
                        src: 'assets/desktop/symbols/hv4/hv4.skel',
                    },
                    {
                        alias: 'hv4Atlas',
                        src: 'assets/desktop/symbols/hv4/hv4.atlas',
                    },
                    //lv1
                    {
                        alias: 'lv1Skel',
                        src: 'assets/desktop/symbols/lv1/lv1.skel',
                    },
                    {
                        alias: 'lv1Atlas',
                        src: 'assets/desktop/symbols/lv1/lv1.atlas',
                    },
                    //lv2
                    {
                        alias: 'lv2Skel',
                        src: 'assets/desktop/symbols/lv2/lv2.skel',
                    },
                    {
                        alias: 'lv2Atlas',
                        src: 'assets/desktop/symbols/lv2/lv2.atlas',
                    },
                    //lv3
                    {
                        alias: 'lv3Skel',
                        src: 'assets/desktop/symbols/lv3/lv3.skel',
                    },
                    {
                        alias: 'lv3Atlas',
                        src: 'assets/desktop/symbols/lv3/lv3.atlas',
                    },
                    //lv4
                    {
                        alias: 'lv4Skel',
                        src: 'assets/desktop/symbols/lv4/lv4.skel',
                    },
                    {
                        alias: 'lv4Atlas',
                        src: 'assets/desktop/symbols/lv4/lv4.atlas',
                    },
                    //scatter
                    {
                        alias: 'scatterSkel',
                        src: 'assets/desktop/symbols/scatter/scatter.skel',
                    },
                    {
                        alias: 'scatterAtlas',
                        src: 'assets/desktop/symbols/scatter/scatter.atlas',
                    },
                    //wild
                    {
                        alias: 'wildSkel',
                        src: 'assets/desktop/symbols/wild/wild.skel',
                    },
                    {
                        alias: 'wildAtlas',
                        src: 'assets/desktop/symbols/wild/wild.atlas',
                    },
                    //special symbol - golden fist
                    {
                        alias: 'special_symbolSkel',
                        src: 'assets/desktop/symbols/special_symbol/special_symbol.skel',
                    },
                    {
                        alias: 'special_symbolAtlas',
                        src: 'assets/desktop/symbols/special_symbol/special_symbol.atlas',
                    },
                    //giant wild
                    {
                        alias: 'giantWildSkel',
                        src: 'assets/desktop/symbols/giant_wild/giant_wild.skel',
                    },
                    {
                        alias: 'giantWildAtlas',
                        src: 'assets/desktop/symbols/giant_wild/giant_wild.atlas',
                    },
                    // anticipation animation
                    {
                        alias: 'anticipationSkel',
                        src: 'assets/desktop/symbols/wild/wild.skel',
                    },
                    {
                        alias: 'anticipationAtlas',
                        src: 'assets/desktop/symbols/wild/wild.atlas',
                    },
                    //sugar park ttf- font 
                    {
                        alias: 'FREEZONE',
                        src: 'assets/desktop/font/suger_motley_forces/Motley_Forces.ttf',
                    },
                    //sugar win- font 
                    {
                        alias: 'sugar_win_amount',
                        src: 'assets/desktop/font/sugar_win_amount/sugar_win_amount.xml',
                    },

                    /*********** below are 8-bit fonts* */
                    //multiplier- font
                    // {
                    //     alias: 'mult_font_yellow',
                    //     src: 'assets/desktop/font/8-bit_quest_multiplier_yellow/8-bit_quest_multiplier_yellow.xml',
                    // },
                    // {
                    //     alias: 'mult_font_blue',
                    //     src: 'assets/desktop/font/8-bit_quest_multiplier_blue/8-bit_quest_multiplier_blue.xml',
                    // },
                    // xml font for number on intro-outro banner -  // UpheavalTT-BRK-Banner
                    // {
                    //     alias: '8-bit_quest_intro_amount',
                    //     src: 'assets/desktop/font/8-bit_quest_intro_amount/8-bit_quest_intro_amount.xml',
                    // },
                    // xml font for number on intro-outro banner & tickets heading
                    // {
                    //     alias: '8-bit_quest_intro_1',
                    //     src: 'assets/desktop/font/8-bit_quest_intro_1/8-bit_quest_intro_1.xml',
                    // },
                    // xml font for number on intro-outro banner & tickets desciption
                    // {
                    //     alias: '8-bit_quest_intro_2',
                    //     src: 'assets/desktop/font/8-bit_quest_intro_2/8-bit_quest_intro_2.xml',
                    // },

                    // xml font for number for win amount
                    // {
                    //     alias: '8-bit_quest_win_amount',
                    //     src: 'assets/desktop/font/8-bit_quest_win_amount/8-bit_quest_win_amount.xml',
                    // },
                    // xml font for number on Wild-symbol
                    // {
                    //     alias: '8-bit_quest_wild_no',
                    //     src: 'assets/desktop/font/8-bit_quest_wild_no/8-bit_quest_wild_no.xml',
                    // },
                    // {
                    //     alias: 'upheavtt',
                    //     src: 'assets/desktop/font/upheavtt/upheavtt.ttf',
                    // },
                    // {
                    //     alias: 'nokiafc22',
                    //     src: 'assets/desktop/font/nokiafc22/nokiafc22.ttf',
                    // },
                    // {
                    //     alias: 'PressStart2P-Regular',
                    //     src: 'assets/desktop/font/PressStart2P-Regular/PressStart2P-Regular.ttf',
                    // },
                ],
            },
            {
                name: 'sound',
                assets: [
                    {
                        alias: 'bet-level',
                        src: 'assets/desktop/sound/ui/betlevel.mp3',
                    },
                    {
                        alias: 'click',
                        src: 'assets/desktop/sound/ui/click.mp3',
                    },
                    {
                        alias: 'base_music_ambient',
                        // src: 'assets/desktop/sound/flf_mx_basegame.mp3',
                        src: 'assets/desktop/sound/base/Bg_ambient.mp3',
                    },
                    {
                        alias: 'base_music_loop',
                        src: 'assets/desktop/sound/base/Bg_Loop.mp3',
                    },
                    {
                        alias: 'Meter_Appear',
                        src: 'assets/desktop/sound/gameloading/Meter_Appear.mp3',
                    },
                    {
                        alias: 'Screen_Falling',
                        src: 'assets/desktop/sound/gameloading/Screen_Falling.mp3',
                    },
                    {
                        alias: 'Water_Fall',
                        src: 'assets/desktop/sound/gameloading/Water_Fall.mp3',
                    },
                    // {
                    //     alias: 'Intro_appear',
                    //     src: 'assets/desktop/sound/base/Intro_appear.mp3',
                    // },
                    {
                        alias: 'free_background_loop',
                        src: 'assets/desktop/sound/freegame/Fg_Loop.mp3',
                    },
                    {
                        alias: 'Scatter_Trigger',
                        src: 'assets/desktop/sound/freegame/Scatter_Trigger.mp3',
                    },
                    {
                        alias: 'Free_Game_Banner_Appear',
                        src: 'assets/desktop/sound/freegame/Free_Game_Banner_Appear.mp3',
                    },
                    {
                        alias: 'Free_Game_Banner_Disppear',
                        src: 'assets/desktop/sound/freegame/Free_Game_Banner_Disppear.mp3',
                    },
                    // {
                    //     alias: 'freegame_banner_outro',
                    //     src: 'assets/desktop/sound/freegame/8bq_sx_free_game_outro.wav',

                    // },
                    // {
                    //     alias: 'scatter_trigger',
                    //     src: 'assets/desktop/sound/freegame/8bq_mx_intro_appear.mp3',

                    // },
                    {
                        alias: 'reel_stop',
                        src: 'assets/desktop/sound/spin/Reel_Stop.mp3',
                    },
                    {
                        alias: 'Special_Symbol_Landing',
                        src: 'assets/desktop/sound/spin/Special_Symbol_Landing.mp3',
                    },
                    {
                        alias: 'Multiplier_Update',
                        src: 'assets/desktop/sound/spin/Multiplier_Update.mp3',
                    },
                    {
                        alias: 'Meter_Section_Fills',
                        src: 'assets/desktop/sound/spin/Meter_Section_Fills.mp3',
                    },
                    {
                        alias: 'Special_Symbol_Provides_Additional_Wilds',
                        src: 'assets/desktop/sound/spin/Special_Symbol_Provides_Additional_Wilds.mp3',
                    },
                    {
                        alias: 'Special_Symbol_Activates',
                        src: 'assets/desktop/sound/spin/Special_Symbol_Animation_Activates.mp3',
                    },
                    {
                        alias: 'Special_Symbol_Provides_Additional_Multiplier',
                        src: 'assets/desktop/sound/spin/Special_Symbol_Provides_Additional_Multiplier.mp3',
                    },
                    {
                        alias: 'Meter_Gets_Full',
                        src: 'assets/desktop/sound/spin/Meter_Gets_Full.mp3',
                    },
                    {
                        alias: 'Giant_Wild',
                        src: 'assets/desktop/sound/spin/Giant_Wild.mp3',
                    },
                    {
                        alias: 'symbol_win',
                        src: 'assets/desktop/sound/win/Win_Without_Multiplier.mp3',
                    },
                    {
                        alias: 'symbol_win_multiply',
                        src: 'assets/desktop/sound/win/Win_With_Multiplier.mp3',
                    },
                    {
                        alias: 'symbol_cascade',
                        src: 'assets/desktop/sound/win/Symbol_Blast.mp3',
                    },
                    {
                        alias: 'win_loop',
                        src: 'assets/desktop/sound/bigwin/Win_Loop.mp3',
                    },
                    {
                        alias: 'Win_Tear_Impact',
                        src: 'assets/desktop/sound/bigwin/Win_Tear_Impact.mp3',
                    },
                    {
                        alias: 'win_tickup',
                        src: 'assets/desktop/sound/bigwin/Win_Count_up.mp3',
                    },
                    {
                        alias: 'win_tickup_end',
                        src: 'assets/desktop/sound/bigwin/Win_Count_Up_End.mp3',
                    },
                ],
            },

        ],
    }
};

